import { ActivityStatus, Badge, BadgeColor, Icon } from "@cca/components";

interface ReviewBadgeProps {
  status: ActivityStatus;
  feedbackCount?: number;
}

interface BadgeParams {
  color: BadgeColor;
  text: string;
}

const getBadgeParams = (status: ActivityStatus): BadgeParams => {
  const statusMap: Record<ActivityStatus, BadgeParams> = {
    [ActivityStatus.NotStarted]: {
      color: BadgeColor.Info,
      text: "Not Started",
    },
    [ActivityStatus.InProgress]: {
      color: BadgeColor.Primary,
      text: "In Progress",
    },
    [ActivityStatus.PendingGrade]: {
      color: BadgeColor.Warning,
      text: "Pending Grade",
    },
    [ActivityStatus.Completed]: {
      color: BadgeColor.Success,
      text: "Graded",
    },
    [ActivityStatus.Modified]: {
      color: BadgeColor.Primary,
      text: "Modified",
    },
    [ActivityStatus.Exempted]: {
      color: BadgeColor.Info,
      text: "Unused",
    },
  };

  return (
    statusMap[status] || {
      color: BadgeColor.Info,
      icon: "minus",
      text: "Unknown",
    }
  );
};

const ReviewBadge: React.FC<ReviewBadgeProps> = ({ status, feedbackCount }) => {
  const { color, text } = getBadgeParams(status);

  return (
    <>
      <Badge className="w-fit" color={color} size="sm" variant="outlined">
        {text}
      </Badge>
      {!!feedbackCount && feedbackCount > 0 && (
        <>
          <Icon className="ml-2 text-gray-500" type="comments" />
          <span className="font-normal"> ({feedbackCount})</span>
        </>
      )}
    </>
  );
};

export default ReviewBadge;
